import React from 'react';
import { Form, Dropdown } from 'react-bootstrap';

class DropdownWithFilter extends React.Component {

    state = {
        searchValue: null
    }

    render() {
        return (
            <>
                <Dropdown className={this.props.className || "dropdown"}>
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                        <p className='dropChooseText'>{this.props.selectedItem ? this.props.label(this.props.selectedItem) : (this.props.defaultLabel || "выберите")}</p>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Form.Control
                            type="text"
                            className="filterSearch"
                            placeholder="часть названия"
                            onChange={(event) => { this.setState({ searchValue: event.target.value }); }}
                        />
                        <div className='dropdown-itemsContainer'>
                        {this.props.items && this.props.items.map((item, index) => (
                            (!this.state.searchValue || (this.props.label(item).toLowerCase().indexOf(this.state.searchValue.toLowerCase()) >= 0))
                            ?
                            <Dropdown.Item
                                key={index}
                                onClick={(e) => { this.props.onItemClick(item) }}>
                                {this.props.label(item)}
                            </Dropdown.Item>
                            : null
                        ))}
                        </div>
                    </Dropdown.Menu>
                </Dropdown>
            </>
        );
    }

}

export default DropdownWithFilter;